import React from 'react';
import { useMapContext } from '../context/MapContext';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const Header = () => {
  const { geojsonData } = useMapContext();
  const { t } = useTranslation();
  
  // Function to export GeoJSON
  const handleExport = () => {
    if (!geojsonData || !geojsonData.features || geojsonData.features.length === 0) {
      alert(t('editTools.messages.noDataToExport', 'No data to export'));
      return;
    }
    
    // Create a downloadable blob
    const blob = new Blob([JSON.stringify(geojsonData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    // Determine filename based on content
    let filename = 'electoral_boundaries.geojson';
    
    // If all features have the same KODPAR, use that for the filename
    if (geojsonData.features.length > 0) {
      const firstKodpar = geojsonData.features[0].properties.KODPAR;
      const allSameKodpar = geojsonData.features.every(f => f.properties.KODPAR === firstKodpar);
      
      if (allSameKodpar && firstKodpar) {
        filename = `${firstKodpar.replace('.', '')}.geojson`;
      }
    }
    
    // Create and trigger download link
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    
    // Clean up
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  };
  
  // Import functionality removed - now handled in sidebar
  
  return (
    <div className="header">
      <h1>{t('app.title')}</h1>
      <div className="header-controls">
        <div className="btn-group-header">
          {/* Import button removed to avoid duplication with sidebar import */}
          <LanguageSelector />
          <button className="btn btn-success btn-export" onClick={handleExport} disabled={!geojsonData}>
            <i className="fas fa-file-export"></i> {t('toolbar.exportGeoJSON')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
